<template>
  <div class="mm_body">
    <mmheader :mm-site-url="mm_site_url"></mmheader>
    <div style="clear: both;"></div>
    <section class="container" style="padding-top: 72px !important;">
      <div class="row justify-content-center mb-3">
        <div class="row justify-content-center mb-3">
          <div class="col-md-8 col-xs-11">
            <div class="mt-4 text-center">
              <img src="@/assets/mm_logo_small.png" alt="" width="75">
            </div>
            <div class="h5 mt-3 mb-2 text-center font-weight-bold">Select a subscription to that fits your team size.</div>
            <div class="mt-5 mb-4 text-center">
              <flash-message autoHide variant="success"></flash-message>
              <b-alert
                :show="dismissCountDown"
                dismissible
                variant="danger"
                @dismissed="dismissCountDown=0"
                @dismiss-count-down="countDownChanged"
                >
                {{ warning_message }}
              </b-alert>
            </div>


          </div>

          <div class="col-md-8 col-xs-11">
            <div class="border rounded shadow px-4 py-2 mb-3">
              <div class="row">
                <div class="col-5">
                  <div class="font-weight-bold h6 mb-2">{{ accountName }}</div>
                  <div class="font-weight-bold h6 mb-2">{{ org_address }}{{ mailing_address_2 != '' ? ', ' + mailing_address_2 : '' }}</div>
                  <div class="font-weight-bold h6 mb-2">{{ org_city }}, {{ org_state }} {{ org_zip }}</div>
                </div>
                <div class="col-7">
                  <div class="font-weight-bold h6 mb-2 text-right">{{ primaryUserName }}</div>
                  <div class="h6 mb-2 text-right text-break">{{ primaryUserEmail }}</div>
                  <div class="h6 mb-2 text-right">{{ primaryPhone }}</div>
                </div>
              </div>

              <div class="row">
                <div class="col-8">
                  <div>
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="is_billing_address_same" v-model="is_billing_address_same" value="1" @change="billingAddressChange($event)">
                      <label class="custom-control-label" for="is_billing_address_same">Billing address is the same as location address</label>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="text-right">
                    <a class=""><i class="fa fa-pencil" aria-hidden="true" style="color: #00ACEE; cursor: pointer;" @click="editPageRedirect()"></i></a>
                  </div>
                </div>
              </div>

              <div class="row my-3" v-if="is_billing_address_same == 0">
                <div class="col">

                  <div class="h6 font-weight-bold">Billing Address</div>
                  <div class="form-group">
                    <input 
                      name="billing_name" 
                      id="billing_name"
                      ref="billing_name"
                      v-validate="'required'"
                      maxlength="250" 
                      v-model="billing_name"
                      class="form-control" 
                      placeholder="Billing Name">
                    <div v-if="verrors.firstByRule('billing_name', 'required')" class="margin-bottom-5 validate-warning-msg">The billing name field is required</div>
                  </div>
                  <div class="form-group">
                    <select 
                      name="billing_country"
                      id="billing_country"
                      ref="billing_country"                    
                      v-model="billing_country"
                      v-validate="'required'" 
                      v-on:change="getStateLists(billing_country)"
                      class="form-control">
                          <option v-for="(type, index) in country_options" :key="index" :value="type.value">{{ type.text }}</option>
                      </select>
                    <div v-show="verrors.has('billing_country')" class="validate-warning-msg">The billing country field is required</div>
                  </div> 

                  <div class="form-group">
                    <input 
                      name="billing_address" 
                      id="billing_address"
                      ref="billing_address"
                      v-validate="'required'"
                      maxlength="250" 
                      v-model="billing_address"
                      class="form-control" 
                      placeholder="Billing Address 1">
                    <div v-if="verrors.firstByRule('billing_address', 'required')" class="margin-bottom-5 validate-warning-msg">The billing address 1 field is required</div>
                  </div>

                  <div class="form-group">
                    <input 
                      type="text" 
                      name="billing_address2" 
                      id="billing_address2"
                      ref="billing_address2"
                      v-model="billing_address2"
                      class="form-control" 
                      placeholder="Billing Address 2"
                      maxlength="250">
                  </div>

                  <div class="form-group">
                    <input 
                      type="text"
                      name="billing_city" 
                      id="billing_city"
                      ref="billing_city"
                      v-validate="'required'"
                      maxlength="100" 
                      v-model="billing_city" 
                      class="form-control" 
                      placeholder="Billing City">
                      <div v-show="verrors.has('billing_city')" class="validate-warning-msg">The billing city field is required</div>
                  </div>

                  <div class="form-group">
                    <select 
                      name="billing_state" 
                      id="billing_state"
                      ref="billing_state"
                      v-validate="'required'" 
                      v-model="billing_state" 
                      class="form-control">
                      <option v-for="(type, index) in state_options" :key="index" :value="type.value">{{ type.text }}</option>
                    </select>
                    <div v-if="verrors.firstByRule('billing_state', 'required')" class="margin-bottom-5 validate-warning-msg">The billing state/province field is required</div>
                  </div>

                  <div class="form-group">
                    <input 
                      type="text" 
                      name="billing_zip" 
                      id="billing_zip"
                      ref="billing_zip"
                      v-validate="{ rules: { required: true, regex: getPostalCodeRegex() } }"
                      v-model="billing_zip"
                      maxlength="10"
                      class="form-control" 
                      placeholder="Billing Zip">
                    <div v-if="verrors.firstByRule('billing_zip', 'required')" class="margin-bottom-5 validate-warning-msg">The billing zip/postal code field is required</div>
                    <div v-if="verrors.firstByRule('billing_zip', 'regex')" class="margin-bottom-5 validate-warning-msg">The billing zip/postal code format is invalid</div>
                  </div> 
                </div>
              </div>
            </div>

            <div class="h3 col-12 p-0 mb-3 mt-1">
              Subscription
            </div>

            <div class="border rounded shadow px-4 py-3 mb-4">
            
              <div class="row">
                  <div class="col-8">
                    {{ packageName }}
                    <a class="pt-2 "><i class="fa fa-pencil" aria-hidden="true" style="color: #00ACEE; cursor: pointer;" @click="subscriptionlistRedirect()"></i></a>
                  </div>
                  <div class="col-4 text-right pr-4">
                    &#36;{{ packagePrice }}
                  </div>
              </div>
              <div class="row pt-2" v-if="this.unlimited == false">
                  <div class="col-8">
                    Additional Mentees: <b-form-select class="col-2 ma-input-field" v-model="additionalSeat" name="unit" :options="qty_options" placeholder="Qty" @change="getAdditionalPriceforSubscription">           
                    </b-form-select>
                  </div>
                  <div class="col-4 text-right pr-4" v-if="totaladditionalSeatPrice > 0">
                    &#36;{{ totaladditionalSeatPrice }}
                  </div>
              </div>
              <div class="row mt-2">
                  <div class="col-8">
                    {{ packageQty }}
                  </div>
                  <div class="col-4 text-right pr-3">
                    <div v-if="type == 'yearly'" class="mb-1 pr-2 text-right">${{ total_amt }}/annually</div>
                    <div  v-if="type == 'monthly'" class="pr-2 mb-0  text-right">${{ total_amt }}/month</div>
                    <div  v-if="type == 'monthly'" class="annual mb-1 pr-2 text-right"><i>Annual subscription</i></div>
                  </div>
              </div>
              <div class="clear"></div>

            </div>

            <div class="h3 col-12 p-0 mb-3 mt-1">
              Payment Method
            </div>

            <div class="border rounded shadow px-4 py-2">


              <div class="h6 mb-1 mt-2 pr-2 text-right"><span class="font-weight-bold mr-2">Total Due: </span> ${{ total_amt }} </div>

              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="purchase_card_name" class="h6 mb-0">Name on card</label>
                    <input 
                      id="purchase_card_name"
                      type="text" 
                      class="form-control" 
                      name="name_on_card" 
                      v-model="nameOnCard" 
                      v-validate="'required'"
                      placeholder="">
                    <div v-if="verrors.firstByRule('name_on_card', 'required')" class="margin-bottom-5 validate-warning-msg">Name on Card is required</div>
                  </div>

                  <div class="form-group">
                    <label for="purchase_card_number" class="h6 mb-0">Card number</label>
                    <input 
                      id="purchase_card_number"
                      type="text" 
                      class="form-control" 
                      name="card_no" 
                      v-model="cardNumber" 
                      maxlength="16"
                      v-validate="'required|numeric'"
                      placeholder="">
                    <div v-if="verrors.firstByRule('card_no', 'required')" class="margin-bottom-5 validate-warning-msg">Card Number is required</div>
                    <div v-if="verrors.firstByRule('card_no', 'numeric')" class="margin-bottom-5 validate-warning-msg">Card Number must contain numeric characters only</div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="form-group">
                        <label for="purchase_card_month" class="h6 mb-0">Month</label>
                        <select 
                          id="purchase_card_month"
                          class="form-control" 
                          name="exp_month" 
                          v-model="expMonth" 
                          v-validate="'required'">
                          <option value="">Month</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                      </select>
                      <div v-if="verrors.firstByRule('exp_month', 'required')" class="margin-bottom-5 validate-warning-msg">Month is required</div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <label for="purchase_card_year" class="h6 mb-0">Year</label>
                        <b-form-select
                          id="purchase_card_year"
                          class="form-control"
                          name="exp_year" 
                          v-model="expYear" 
                          v-validate="'required'"
                          :options="year_options">
                        </b-form-select>
                        <div v-if="verrors.firstByRule('exp_year', 'required')" class="margin-bottom-5 validate-warning-msg">Year is required</div>  
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>

            <div class="chkboxwrapper col-12 p-0 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                    type="checkbox"
                    id="terms"
                    name="terms"
                    v-model="terms"
                    value="1" class="custom-control-input" v-validate="'required'">
                <label class="custom-control-label" for="terms">I agree to the <a href="https://mentormentee.com/terms-of-use/" target="_blank" style="color: #00ACEE !important;">terms of service</a> and <a href="https://mentormentee.com/privacy-policy/" target="_blank" style="color: #00ACEE !important;">privacy policy.</a></label>
                <div v-if="verrors.firstByRule('terms', 'required')" class="margin-bottom-5 validate-warning-msg">Field is required</div>
              </div>
            </div>


            <div class="text-center mt-4">
              <button type="submit" class="btn btn-lg font-weight-bold text-center px-5" @click="processPayment()" :disabled="!isFormValid || disable_purchase_btn" :class="isFormValid ? 'btn-blue' : 'btn-blue-purchase-disabled'">Activate Account</button>
            </div>

            <div class="text-center mt-2 mb-5">
              <a class="small font-weight-bold" style="text-decoration: underline; color: #002F42; cursor: pointer;" @click="loginRedirect()">I'm not ready to purchase?</a>
            </div>




          </div>
        </div>
      </div>
    </section>
    <mmfooter :mm-site-url="mm_site_url"></mmfooter>
  </div>
</template>

<script>
import axios from 'axios';
import mmheader from '@/components/mm_header';
import mmfooter from '@/components/mm_footer';
import router from '../../router/index.js';

export default {
  data() {
    return {
      terms: false,
      mm_site_url: process.env.MM_SITE_URL,
      nameOnCard: '',
      cardNumber: '',
      expMonth: '',
      expYear: '',
      cvvValue: '',
      year_options: [],
      is_billing_address_same: 1,
      country_options: [],
      state_options: [],
      org_address: '',
      org_country: 'US',
      mailing_address_2: '',
      org_city: '',
      org_state: '',
      org_zip: '',
      billing_name: '',
      billing_address: '',
      billing_address2: '',
      billing_city: '',
      billing_state: '',
      billing_country: '',
      billing_zip: '',
      total_amt: 0,
      subscriptionId: '',
      subscriptionPrice: '',
      subscriptions: [],
      packageId: '',
      unit: 1,
      type: '',
      accountName: '',
      primaryUserName: '',
      primaryUserEmail: '',
      primaryPhone: '',
      success_message: '',
      warning_message: '',
      dismissCountDown: 0,
      disable_purchase_btn: false,  
      packagePrice: '',
      packageName: '',
      maxAdditionalSeatLimit: '',
      additionalSeatPrice: '',    
      packageQty: '',
      totaladditionalSeatPrice: '',
      qty_options: [
        { value: '', text: '0' },
        { value: 1, text: 1 },
        { value: 2, text: 2 },
        { value: 3, text: 3 },
        { value: 4, text: 4 },
        { value: 5, text: 5 },
        { value: 6, text: 6 },
        { value: 7, text: 7 },
        { value: 8, text: 8 },
        { value: 9, text: 9 },
        { value: 10, text: 10 },
        { value: 11, text: 11 },
        { value: 12, text: 12 },
        { value: 13, text: 13 },
        { value: 14, text: 14 },
        { value: 15, text: 15 },
        { value: 16, text: 16 },
        { value: 17, text: 17 },
        { value: 18, text: 18 },
        { value: 19, text: 19 },
        { value: 20, text: 20 },
      ],
      additionalSeat: '',
      price: '',
      packageUnit: '',
      unlimited: false,

    }
  },
  components: {
    mmheader,
    mmfooter,
  },
  computed: {
    isFormValid() {
      if (!this.verrors.any() && this.nameOnCard && this.cardNumber && this.expMonth && this.expYear) {
        return true;
      }

      return false;
    }
  },
  methods: {
    getAdditionalPriceforSubscription: function() {
      this.totaladditionalSeatPrice = Math.round(parseInt((this.additionalSeat * this.additionalSeatPrice)), 2).toFixed(2);
      var price = this.packagePrice.replace(",", "");
      this.total_amt = Math.round(parseFloat(price) + parseFloat(this.totaladditionalSeatPrice)).toFixed(2);
      this.unit = parseInt(this.packageUnit + this.additionalSeat);
    },
    subscriptionlistRedirect() {
      this.$router.push({ name: 'mmCreateAccountSubscriptionLists'});
    },
    editPageRedirect() {
      this.$router.push({ name: 'mmCreateAccountEdit'});
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clickPrimary: function(index) {
      for(var i=0; i < this.subscriptions.length; i++) {
        this.subscriptions[i].isSelected = 0;
        this.subscriptions[i].checked = false;
      }
      this.subscriptions[index].isSelected = 1;
      this.subscriptions[index].checked = true;
      this.packageId = this.subscriptions[index].id;
      this.total_amt = this.subscriptions[index].packagePrice;
      this.unit = this.subscriptions[index].qty;
    },
    loginRedirect() {
      this.$store.dispatch('create_account', '');              
      this.$store.dispatch('create_account_obj', '');              
      router.push("/login");

    },
    billingAddressChange(event) {
      if(event.target.checked == true) {
        this.billing_address = this.org_address;
        this.billing_country = this.org_country;
        this.billing_address2 = this.mailing_address_2;
        this.billing_city = this.org_city;
        this.billing_state = this.org_state;
        this.billing_zip = this.org_zip;
        this.billing_name = this.primaryUserName;
      }
      else {
        this.billing_address = '';
        this.billing_country = '';
        this.billing_address2 = '';
        this.billing_city = '';
        this.billing_state = '';
        this.billing_zip = '';
        this.billing_name = '';
      }
    },
    onChangePrice() {
      //this.total_amt = Math.round(parseInt((this.unit*899.00) + 3999.00), 2);
    },
    processPayment() {

        this.$validator.validateAll().then((result) => {
          if (!result) {
            console.log("ERROR" + result)
            console.log(this.verrors);
            return;
          }
          else {
            this.disable_purchase_btn = true;
            
            axios('/custom/orders', 
            {
                method: 'POST',
                data: {
                        "subscription_id": this.subscriptionId,
                        "packageId": this.packageId,
                        "subscription_price": this.total_amt,
                        "units": this.unit,
                        "additionalSeat": this.additionalSeat,
                        "type": this.type,
                        "subscription_total": this.total_amt,
                        "account_id": this.$store.state.create_account_accountId,
                        "user_id": this.$store.state.create_account_uid,
                        "billing_name": this.billing_name,
                        "billing_address": this.org_address,
                        "billing_address2": this.mailing_address_2,
                        "billing_city": this.org_city,
                        "billing_state": this.org_state,
                        "billing_country": this.org_country,
                        "billing_zip": this.org_zip,
                        "billing_phone": '',
                        "payment_method": "credit_card",
                        "name_oncard": this.nameOnCard,
                        "card_number": this.cardNumber,
                        "exp_month": this.expMonth,
                        "exp_year": this.expYear.toString().substr(-2),
                        "cvv_value": this.cvvValue,
                },
            })
            .then((response) => {
              this.disable_purchase_btn = false;
              if(response.data.msg == "failed") {
                this.warning_message = 'Payment failed.';
                this.dismissCountDown = 5;
                this.nameOnCard = '';
                this.cardNumber = '';
                this.expMonth = '';
                this.expYear = '';
                this.cvvValue = '';

              }
              if(response.data.msg == "success") {
                this.flash({ message: "Account activated successfully!", variant: 'success' });
                this.$store.dispatch('create_account', '');              
                this.$store.dispatch('create_account_obj', '');              
                this.$store.dispatch('create_account_billing', '');              
                router.push("/login");

              }
            })
            .catch(error => {
              this.disable_purchase_btn = false;
            });

          }
      }).catch(() => {
        // catches the error;
      });

    },

    getExpiryYears() {
      this.year_options = [
        { value: '', text: 'Year' },
      ];       
      var min = new Date().getFullYear()
      var max = min + 20;
      for (var i = min; i <= max; i++) {
        var yoptions = { value: i, text: i };
        this.year_options.push(yoptions);
      }
    },
    getPostalCodeRegex: function () {
      if (this.billing_country == "US") {
        return /^[0-9]{5}(?:-[0-9]{4})?$/;
      } else if (this.billing_country == "CA") {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      }
      return /./;
    },
    getCountryLists: function () {
      axios.get('/custom/account-create-country-lists', {})
        .then(response => {
          this.country_options = response.data;
        })
        .catch(function (error) {});
    },
    getStateLists: function (CountryCode) {
      this.org_state = '';
      if (CountryCode == '') {
        CountryCode = null;
      }
      axios.get('/custom/get-state-lists/' + CountryCode, {})
        .then(response => {
          response.data[0].text = "Select State / Province";
          this.state_options = response.data;
        })
        .catch(function (error) {});
      },
      getSubscriptionLists() {

        axios('/custom/get-account-seat-subscription-lists-detail/'+ this.$store.state.create_account_accountId,
        {
          method: 'GET',     
          params: {
            type: this.type,
            packageId: this.packageId,
          }
        })
        .then(resp => {        
          this.total_amt = resp.data.packagePrice;
          this.packagePrice = resp.data.packagePrice;
          this.price = resp.data.packagePrice;
          this.packageName = resp.data.packageName;
          this.maxAdditionalSeatLimit = resp.data.maxAdditionalSeatLimit;
          this.subscriptionId = resp.data.subscriptionId;
          this.unit = resp.data.unit;
          this.packageUnit = resp.data.unit;
          this.packageQty = resp.data.packageQty;
          this.unlimited = resp.data.unlimited;
          this.additionalSeatPrice = resp.data.additionalSeatPrice;
          if(this.maxAdditionalSeatLimit != '') {
            this.qty_options = [];
            var qty =  { value: '', text: 0 };
            this.qty_options.push(qty);
            for(var i=1; i <= this.maxAdditionalSeatLimit; i++) {
                var qty = {value: i, text: i};
                this.qty_options.push(qty);
            }
          }
        })
        .catch(() => {
        });      

      },

  },
  created() {
    if(!this.$store.state.create_account_email) {
      this.$router.push({ name: 'mmcreateaccount'})
    }
    this.type = this.$store.state.create_account_billing_type;
    this.packageId = this.$store.state.create_account_billing_packageId;
    this.getExpiryYears();
    this.getCountryLists();
    this.getSubscriptionLists();
    this.getStateLists(this.org_country);
    //this.total_amt = Math.round(parseInt((this.unit*899.00) + 3999.00), 2);

      axios.get('/custom/get-account-user-details', {
        params: {
          account_id: this.$store.state.create_account_accountId,
          user_id: this.$store.state.create_account_uid,
        }

      })
      .then(response => {
        this.org_address = response.data.account_address;
        this.org_country = response.data.account_country;
        this.mailing_address_2 = response.data.account_address2;
        this.org_city = response.data.account_city;
        this.org_state = response.data.account_state;
        this.org_zip = response.data.account_zip;
        this.billing_address = response.data.account_address;
        this.billing_country = response.data.account_country;
        this.billing_address2 = response.data.account_address2;
        this.billing_city = response.data.account_city;
        this.billing_state = response.data.account_state;
        this.billing_zip = response.data.account_zip;
        this.primaryUserName = response.data.primary_user_name;
        this.billing_name = response.data.primary_user_name;
        this.primaryUserEmail = response.data.primary_user_email;
        this.accountName = response.data.account_name;
        this.primaryPhone = response.data.primary_phone;

      })
      .catch(function (error) {

      });


  },
}
</script>

<style scoped>
.mm_body {
  /* font-size: 20px !important; */
  color: #002F42;
  max-width: 2400px;
  margin: auto;
  font-family: "proxima-nova", Arial, verdana !important;
}
.btn-blue {
  font-size: 20px;
  padding: 5px 30px 5px 30px;
  border-radius: 5px;
  color: white;
}
.btn-blue:hover,
.btn-blue-purchase-disabled:hover {
  color: white;
}
.btn-blue-purchase-disabled {
  font-size: 20px;
  padding: 5px 30px 5px 30px;
  background-color: #b8b8b8 !important;
  border: 1px solid #b8b8b8 !important;
  border-radius: 5px;
  color: white;
}
.custom-select {
  font-size: 1rem !important;
  height: calc(1.5em + 0.75rem + 2px) !important;
}
.rounded {
    border-radius: 1rem !important;
}
.annual {
  font-size: 11px;
}

</style>


// WEBPACK FOOTER //
// src/components/create_account/purchase.vue